import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps, CircularProgress, Typography, Stack } from '@mui/material';

interface ButtonProps extends MuiButtonProps {
  isPending?: boolean;
  loadingText?: string;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ isPending, loadingText, children, ...props }, ref) => (
    <MuiButton ref={ref} {...props} disabled={isPending || props.disabled}>
      {isPending ? (
        <Stack spacing={loadingText ? 2 : 0} direction='row'>
          <Typography fontSize={14}>{loadingText}</Typography>
          <CircularProgress size={20} color='inherit' />
        </Stack>
      ) : (
        children
      )}
    </MuiButton>
  )
);

Button.displayName = 'Button';

export default Button;
